import { useDispatch, useSelector } from 'react-redux';
import KEYVALUESTORE_ACTIONS from '../../../../redux/actions/local';
import { parse } from '../../../parse';

const useAlert = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);

  /*
    puts a message in the local store with key of "dialog", that a modal can consume
  */
  const alert = ({
    step,
    action,
    history,
    selections,
    documents,
    local,
    data,
    params
  }) => {
    const message = parse({
      markup: step.message,
      documents,
      actionSequenceExecutionHistory: history,
      selections,
      local,
      user,
      dataLinks,
      data,
      params
    });

    const title = parse({
      markup: step.messageTitle,
      documents,
      selections,
      actionSequenceExecutionHistory: history,
      local,
      user,
      dataLinks,
      data
    });

    dispatch({
      type: KEYVALUESTORE_ACTIONS.KEY_UPDATED,
      payload: {
        key: 'dialog',
        value: {
          title,
          message,

          confirmButtonText: step.messageConfirmButtonText,
          confirmBehaviour: step.messageConfirmButtonActionType,
          confirmActionId:
            step.messageConfirmButtonActionType === 'action'
              ? step.messageConfirmButtonAction
              : action.id,
          confirmStepId: step.messageConfirmButtonStep,

          cancellable: step.messageShowCancelButton,
          cancelButtonText: step.messageCancelButtonText,
          cancelBehaviour: step.messageCancelButtonActionType,
          cancelActionId:
            step.messageCancelButtonActionType === 'action'
              ? step.messageCancelButtonAction
              : action.id,
          cancelStepId: step.messageCancelButtonStep,
          history
        }
      }
    });

    return {};
  };

  return {
    alert
  };
};

export default useAlert;
